import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { CreateSkillRequest } from "../SkillRecord";

import { skillQueryKeys } from "./skillQueryKeys";

export function useCreateSkill(orgId: string | undefined) {
  const { skillService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateSkillRequest) =>
      skillService.createSkill(request, { orgId }),
    onSuccess: (_data, request) => {
      void queryClient.invalidateQueries({
        queryKey: skillQueryKeys.org(orgId),
      });
      // A new skill seeded with tags can extend the autocomplete vocabulary.
      if ((request.tags?.length ?? 0) > 0) {
        void queryClient.invalidateQueries({
          queryKey: skillQueryKeys.orgTags(orgId),
        });
      }
    },
  });
}
